import { Button, Modal, TextArea } from '@patternfly/react-core';

type Props = {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: () => void;
	titleText?: string;
	textLabel?: React.ReactNode;
	cancelLabel?: string;
	confirmLabel?: string;
	textValue?: string | number | undefined;
	onTextChange?:
		| ((value: string, event: React.ChangeEvent<HTMLTextAreaElement>) => void)
		| undefined;
};

function ChartMetaDataModal(props: Props) {
	return (
		<Modal
			title={props.titleText ?? 'Edit Item'}
			variant="small"
			isOpen={props.isOpen}
			onClose={props.onClose}
			className="edit-modal"
			actions={[
				<Button
					key="cancel"
					variant="secondary"
					onClick={props.onClose}
				>
					{props.cancelLabel ?? 'Cancel'}
				</Button>,
				<Button
					key="save"
					variant="primary"
					onClick={props.onSubmit}
				>
					{props.confirmLabel ?? 'Save'}
				</Button>,
			]}
		>
			<div className="modal-content">
				{props.textLabel}
				<br />
				<TextArea
					rows={9}
					id="modal-textarea"
					value={props.textValue}
					onChange={(value, event) =>
						props.onTextChange && props.onTextChange(value, event)
					}
					placeholder={'Enter chart meta-details here'}
					resizeOrientation="vertical"
				/>
			</div>
		</Modal>
	);
}

export default ChartMetaDataModal;
